export const NOTE_MAX_LENGTH = 100;

export const ICON_BTN_PROPS = { width: '28px', height: '28px', padding: '0', borderRadius: 'var(--radius-sm)', type: 'button' };
